@if (!ratingSuccess) {
<div class="py-1">
  <div
    class="mb-1 text-[28px] leading-none font-bold text-black dark:text-white"
  >
    {{ titleKey | translate }}
  </div>
  @if (ratingPromptContext) {
  <div class="mb-1 text-sm text-grey dark:text-lightGrey">
    {{ contextKey | translate }}
    <span class="italic font-bold text-black dark:text-white">
      {{ getWorkTitle(work) }}
    </span>
  </div>
  <div class="mb-2 text-sm text-grey dark:text-lightGrey">
    {{ "WORK_COMPANION_RATING_PROMPT_PRONOUN" | translate }}
  </div>
  } @else {
  <div class="mb-2 text-sm text-grey dark:text-lightGrey">
    {{ "WORK_COMPANION_RATING_PROMPT_INTRO" | translate }}
    <span class="italic font-bold text-black dark:text-white">
      {{ getWorkTitle(work) }}
    </span>
    {{ language === "en" ? "?" : " ?" }}
  </div>
  }

  <div
    class="mb-1 text-[11px] font-bold tracking-[0.12em] text-grey uppercase dark:text-lightGrey"
  >
    {{ "WORK_COMPANION_RATING_QUICK_LABEL" | translate }}
  </div>

  <div class="mb-2 grid grid-cols-2 gap-1">
    @for (quickRating of quickRatings; track quickRating.value) {
    <button
      class="flex min-h-7 cursor-pointer flex-col items-center justify-center rounded-xl border border-borders-dark bg-white p-1.5 text-center text-black transition-colors duration-150 hover:bg-whitegrey disabled:cursor-not-allowed! disabled:opacity-60 dark:border-borders-darker dark:bg-black-dark dark:text-white dark:hover:bg-black-dark-light"
      [disabled]="isSubmittingRating"
      (click)="setQuickRating(quickRating.value)"
    >
      <span class="mb-1 text-[22px] leading-none">{{ quickRating.emoji }}</span>
      <span class="text-lg leading-none font-bold">{{
        quickRating.value
      }}</span>
      <span class="mt-1 text-base leading-none font-medium">
        {{ quickRating.labelKey | translate }}
      </span>
    </button>
    }
  </div>

  <div
    class="mb-2 flex items-center gap-2 text-sm text-grey dark:text-lightGrey"
  >
    <span class="h-px flex-1 bg-borders-dark dark:bg-borders-darker"></span>
    <span>{{ "WORK_COMPANION_RATING_PRECISE" | translate }}</span>
    <span class="h-px flex-1 bg-borders-dark dark:bg-borders-darker"></span>
  </div>

  <div
    class="mb-2 rounded-lg border border-primary/40 bg-primary/[0.04] p-2 dark:border-primary/25 dark:bg-primary/[0.05]"
  >
    <div class="mb-1 flex min-w-0 items-baseline">
      <span class="text-lg leading-none font-bold text-black dark:text-white">
        {{ hasRatingValue ? currentRating : "-" }}
      </span>
      <span class="ml-0.5 text-sm font-bold text-grey dark:text-borders-dark">
        /100
      </span>
      @if (hasRatingValue) {
      <span class="mx-1 text-sm font-bold text-primary-text">-</span>
      <span class="min-w-0 truncate text-sm font-bold text-primary-text">
        {{ ratingLabelKey | translate }}
      </span>
      }
    </div>

    <input
      class="block touch-pan-y disabled:cursor-not-allowed disabled:opacity-60"
      type="range"
      appStyledRange
      [ngModel]="currentRating"
      [min]="minRating"
      [max]="maxRating"
      step="1"
      [disabled]="isSubmittingRating"
      [attr.aria-label]="'WORK_COMPANION_RATING_PRECISE' | translate"
      (input)="onRatingInput($event)"
      (touchstart)="onTouchStart($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd()"
      (touchcancel)="onTouchCancel()"
    />
    <div
      class="mt-0.5 flex items-center justify-between text-xs text-grey dark:text-borders-dark"
    >
      <span>{{ minRating }}</span>
      <span>{{ maxRating }}</span>
    </div>
  </div>

  <div class="flex items-center gap-2">
    <button
      type="button"
      class="btn btn-tertiary !m-0 !flex !h-[48px] min-w-0 flex-1 !max-w-none items-center justify-center !px-2 !py-0"
      [disabled]="isSubmittingRating"
      (click)="$event.stopPropagation(); skipRating()"
    >
      {{ (saveRating ? "COMPASS_PEPITE_SKIP_RATING" : "LATER") | translate }}
    </button>
    <button
      class="btn btn-grad !m-0 !flex !h-[48px] min-w-0 flex-1 !max-w-none items-center justify-center gap-1 !border !px-2 !py-0 !text-base"
      [disabled]="!canSubmitRating || isSubmittingRating"
      [attr.aria-busy]="isSubmittingRating"
      (click)="submitRating()"
    >
      @if (isSubmittingRating) {
      <img
        src="./assets/images/loading.svg"
        alt=""
        class="h-3 w-3 shrink-0"
        aria-hidden="true"
      />
      }
      <span aria-live="polite">
        {{
          (isSubmittingRating ? "SAVING" : "WORK_COMPANION_VALIDATE_RATING")
            | translate
        }}
      </span>
    </button>
  </div>
  <p class="!mb-0 !mt-1 text-center text-xs text-grey dark:text-lightGrey">
    {{ "WORK_QUICK_RATING_LATER_HINT" | translate }}
  </p>
</div>
} @else {
<div class="py-2">
  <div
    class="mb-2 text-[28px] leading-none font-bold text-black dark:text-white"
  >
    {{ doneTitleKey | translate }}
  </div>
  <div class="text-grey dark:text-lightGrey">
    {{ successMessageKey | translate }}
  </div>
</div>
} @if (showRemoveLink) {
<a
  href=""
  class="mt-1 block text-center text-sm font-semibold text-grey underline decoration-grey/40 underline-offset-4 hover:text-black dark:text-lightGrey dark:hover:text-white"
  (click)="$event.preventDefault(); requestRemove.emit()"
>
  {{ "WORK_QUICK_PROMPT_REMOVE_LINK" | translate }}
</a>
}
